import { apiSlice } from "./apiSlice";

export const managementProfileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createManagementProfile: builder.mutation({
      query: (profileData) => ({
        url: "/managementProfiles/createManagementProfile",
        method: "POST",
        body: profileData,
      }),
      invalidatesTags: ["Management Profile"],
    }),

    deleteProfile: builder.mutation({
      query: (id) => ({
        url: `/managementProfiles/deleteProfile/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Management Profile"],
    }),

    updateManagementProfile: builder.mutation({
      query: ({ profileData, id }) => ({
        url: `/managementProfiles/updateManagementProfile/${id}`,
        method: "PATCH",
        body: profileData,
      }),
      invalidatesTags: ["Management Profile"],
    }),

    sortSeniority: builder.mutation({
      query: ({ profileData, id }) => ({
        url: `/managementProfiles/sortSeniority`,
        method: "PATCH",
        body: profileData,
      }),
      invalidatesTags: ["Management Profile"],
    }),

    getAllProfiles: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/managementProfiles/getAllProfiles?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["Management Profile"],
    }),
    getProfiles: builder.query({
      query: ({ postCategory } = {}) => {
        const params = new URLSearchParams();
        params.append("postCategory", postCategory);

        return {
          url: `/managementProfiles/getProfiles?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["Management Profile"],
    }),
    getProfileById: builder.query({
      query: (id) => ({
        url: `/managementProfiles/getProfileById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateManagementProfileMutation,
  useDeleteProfileMutation,
  useGetAllProfilesQuery,
  useGetProfileByIdQuery,
  useUpdateManagementProfileMutation,
  useGetProfilesQuery,
  useSortSeniorityMutation,
} = managementProfileApi;
